<div
  *ngIf="field && inputControl"
  class="h-[50px] rounded-[10px] py-[15px] px-[25px] overflow-hidden flex items-center gap-3"
  [ngStyle]="{ border: outline ? '1px solid #294D8F' : 'none', 'background-color': outline ? 'none' : '#ebf6fb80' }"
  [class]="invalid ? 'error' : ''"
>
  <ion-icon
    color="secondary"
    [src]="field.icon"
    class="text-[16px]"
    *ngIf="field.icon"
  ></ion-icon>
  <ion-date-picker
    *ngIf="field.type === 'date'"
    [formControl]="inputControl"
    [placeholder]="getTranslatedPlaceholder()"
    [mode]="'ios'"
    [displayFormat]="field.displayFormat"
    [pickerFormat]="field.pickerFormat"
    [min]="field.minDate"
    [max]="field.maxDate"
  ></ion-date-picker>
  <ion-input
    mode="ios"
    [placeholder]="getTranslatedPlaceholder()"
    [type]="field.type"
    [formControl]="inputControl"
    [maskito]="setMask(field.formControlName)"
    (ionInput)="applyMask($event.target.value)"
    [inputmode]="field.type"
  >
    <ion-input-password-toggle
      *ngIf="field.type === 'password'"
      color="secondary"
      slot="end"
      class="absolute right-[-15px] z-50"
    ></ion-input-password-toggle>
  </ion-input>
</div>
